import type { EnvironmentInstance } from '../../../hooks/useEnvironmentInstances';

export type TemplateInstanceNavigationTarget = {
  to: '/sandboxes/$sandboxId';
  params: { sandboxId: string };
  search: { tab: 'overview' };
};

export function buildTemplateInstanceNavigationTarget(
  instance: Pick<EnvironmentInstance, 'id' | 'status'>
): TemplateInstanceNavigationTarget {
  return {
    to: '/sandboxes/$sandboxId',
    params: { sandboxId: instance.id },
    search: { tab: 'overview' },
  };
}
